import React from "react"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import { Box, Text } from "@chakra-ui/react"
import ConfigBlock from "pages/EventShow/Forms/StyleAndConfiguration/ConfigBlock"
import { DioboxEvent } from "sharedTypes"
import UpgradeAlert from "components/elements/UpgradeAlert"
import useCurrentPlanType from "utilities/useCurrentPlanType"
import ModalContentWrapper from "./ModalContentWrapper"

type Props = {
  onHide: () => void
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
  onChangeEventWorkingCopy: (values: Partial<DioboxEvent>) => void
  onResetEventWorkingCopy: () => void
}

const DioboxBrandingModal = ({
  onHide,
  event: {
    portalShowPageHeader,
    portalPageHeader,
    whiteLabel,
  },
  updateEvent,
  onChangeEventWorkingCopy,
  onResetEventWorkingCopy,
}: Props) => {
  const { corporateFeaturesEnabled } = useCurrentPlanType()

  const values = {
    portalShowPageHeader,
    portalPageHeader,
    notWhiteLabel: !whiteLabel,
  }

  const updateEventWithNoWhiteLabel = (data) => {
    const { notWhiteLabel, ...eventToUpdate } = data
    eventToUpdate.whiteLabel = !notWhiteLabel

    return updateEvent(eventToUpdate)
  }

  const handleSubmit = async (data) => {
    await updateEventWithNoWhiteLabel(data)
    onHide()
  }

  const handleCancel = () => {
    onResetEventWorkingCopy()
    onHide()
  }

  return (
    <ModalForm
      size="xl"
      noPadding
      initialValues={values}
      title="Diobox Branding"
      onSubmit={handleSubmit}
      onClose={handleCancel}
      onChange={onChangeEventWorkingCopy}
      disableSubmitWhenNotDirty
    >
      {({ control }) => (
        <ModalContentWrapper>
          <ConfigBlock title="Enabled" switchName="notWhiteLabel" control={control} disabled>
            <Text>
              Display Diobox branding in the page footer.
            </Text>
            {!corporateFeaturesEnabled && <Box mt={4}><UpgradeAlert noBorder text="Corporate plan required to hide branding" /></Box>}
          </ConfigBlock>
        </ModalContentWrapper>
      )}
    </ModalForm>
  )
}

export default DioboxBrandingModal
